import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid, date } from '@/helpers/mongoHelpers'

export default function useAreaEdit() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { route, router } = useRouter()
  const { getItem, updateItem, getItems } = useLambda()
  const area = ref({})
  const isSubmitting = ref(false)
  const query = { _id: oid(route.value.params.id) }
  const collection = 'area'

  const show = async () => {
    isSubmitting.value = true

    try {
      const item = await getItem({ collection, query })
      if (!item) throw new Error('Item not found')

      const leadsOptions = await getItems({ collection: 'worker', query: { _id: { $in: item.areaLeads || [] } }})
      item.areaLeads = leadsOptions.map(({ _id, name }) => ({ value: _id.toString(), title: name }))

      area.value = item
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.area_fetch_error'))
    } finally {
      isSubmitting.value = false
    }
  }

  const update = async data => {
    isSubmitting.value = true

    try {
      const action = { $set: { 
        name: data.name?.value || '',
        areaLeads: Array.isArray(data.areaLeads?.value)
          ? data.areaLeads?.value?.map(e => typeof e === 'string' ? oid(e) : oid(e.value))
          : []
      }}

      await updateItem({ collection, query, action })

      showSuccessMessage(i18n.t('message.area_updated'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.area_update_error'))
    } finally {
      router.push({ name: 'organization-area-list' })
      isSubmitting.value = false
    }
  }

  return {
    update,
    show,
    area,
    isSubmitting,
  }
}
